import React, { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ButtonDropdown from 'ui/atoms/ButtonDropdown/ButtonDropdown'
import NewButton from 'ui/atoms/NewButton/NewButton'
import { Subtype } from '../PublishOptimizationResultButton.d'

type PublishButtonProps = {
  hasSubtypes: boolean
  subtypes: Subtype[]
  tooltipTitle: string
  isPublishing: boolean
  isButtonDisabled: boolean
  onOpenModal: (subtype?: Subtype) => void
}

export default function PublishButton({
  hasSubtypes,
  subtypes,
  tooltipTitle,
  isPublishing,
  isButtonDisabled,
  onOpenModal,
}: PublishButtonProps): ReactElement {
  const { t } = useTranslation()
  const buttonLabel = useMemo(() => {
    if (isPublishing) {
      return t('Publishing production plan') + '...'
    }

    return t('Publish production plan')
  }, [isPublishing, t])

  if (hasSubtypes) {
    return (
      <ButtonDropdown
        variant="success"
        label={buttonLabel}
        icon="far fa-rocket"
        loading={isPublishing}
        disabled={isButtonDisabled}
        tooltip={{
          title: tooltipTitle,
        }}
        data-testid="publish-button" // e2e: publish button (subtypes path), decoupled from display copy — do not remove
        onButtonClick={() => onOpenModal()}
        dropdownItems={subtypes.map((subtype) => ({
          label: subtype.subtype_display_name,
          onClick: () => onOpenModal(subtype),
        }))}
      />
    )
  }

  return (
    <NewButton
      variant="success"
      label={buttonLabel}
      icon="far fa-rocket"
      loading={isPublishing}
      disabled={isButtonDisabled}
      tooltip={{
        title: tooltipTitle,
      }}
      data-testid="publish-button" // e2e: publish button (no-subtypes path), decoupled from display copy — do not remove
      onClick={() => onOpenModal()}
    />
  )
}
